import advancedRoutes from "./advanced"
import applicationRoutes from "./applications"

const appRoutes = [
  {
    path: "",
    name: "",
    component: () => import("@/layout/DashboardLayout.vue"),
    redirect: "/home",
    meta: {
      isProtected: true
    },
    children: [
      {
        path: "/home",
        name: "home",
        component: () => import("@/modules/home/pages/Home.vue"),
        meta: {
          isProtected: true,
          navigation: [
            {
              title: "Home",
              translationKey: "common.home",
              routeName: "home"
            }
          ]
        }
      },
      ...advancedRoutes,
      ...applicationRoutes
    ]
  }
]

export default appRoutes
